import { Box } from './box';

export class BoxSmall extends Box
{
  constructor(
      canvas: HTMLCanvasElement,
      svgReference: SVGElement|string,
      options: Object = {})
  {
    const model = {
      boxTop: {
        position: [
            -0.928, -1.347,  0.127,
             0.928, -1.347,  0.127,
             0.928,  1.347,  0.127,
            -0.928,  1.347,  0.127,
            // Top
            -0.928,  1.347,  0.127,
             0.928,  1.347,  0.127,
             0.928,  1.347, -0.127,
            -0.928,  1.347, -0.127,
            // Bottom
            -0.928, -1.347, -0.127,
             0.928, -1.347, -0.127,
             0.928, -1.347,  0.127,
            -0.928, -1.347,  0.127,
            // Right
             0.928, -1.347,  0.127,
             0.928, -1.347, -0.127,
             0.928,  1.347, -0.127,
             0.928,  1.347,  0.127,
            // Left
            -0.928, -1.347, -0.127,
            -0.928, -1.347,  0.127,
            -0.928,  1.347,  0.127,
            -0.928,  1.347, -0.127
        ],
        element: [
            // Front
             0,  1,  2,
             0,  2,  3,
            // Top
             4,  5,  6,
             4,  6,  7,
            // Bottom
             8,  9, 10,
             8, 10, 11,
            // Right
            12, 13, 14,
            12, 14, 15,
            // Left
            16, 17, 18,
            16, 18, 19,
        ],
        texture: [
            // Front
            0.157, 0.879,
            0.843, 0.879,
            0.843, 0.121,
            0.157, 0.121,
            // Top
            0.157, 0.121,
            0.843, 0.121,
            0.843, 0.050,
            0.157, 0.050,
            // Bottom
            0.157, 0.950,
            0.843, 0.950,
            0.843, 0.879,
            0.157, 0.879,
            // Right
            0.843, 0.879,
            0.937, 0.879,
            0.937, 0.121,
            0.843, 0.121,
            // Left
            0.063, 0.879,
            0.157, 0.879,
            0.157, 0.121,
            0.063, 0.121
        ],
        svgReference: svgReference,
        updateFrequency: 'regular',
        vertexNormal: [
            // Front
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            // Top
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            // Bottom
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            // Right
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            // Left
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0
        ],
      },
      boxBottom: {
        position: [
            // Back
            -0.928, -1.347, -0.127,
            -0.928,  1.347, -0.127,
             0.928,  1.347, -0.127,
             0.928, -1.347, -0.127
         ],
        element: [
            // Back
             0,  1,  2,
             0,  2,  3,
        ],
        color: [ 0.95, 0.95, 0.95 ],
        vertexNormal: [
            // Front
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
        ],
      }
    };
    super(canvas, model, options);
  }
}
